import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { CategoryPicker } from '../components/CategoryPicker';
import { PrioritySelector } from '../components/PrioritySelector';
import { ConfirmModal } from '../components/ConfirmModal';
import { useUser } from '../contexts/UserContext';
export function CreateGoalPage() {
  const navigate = useNavigate();
  const {
    addGoal
  } = useUser();
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState<'Work' | 'Study' | 'Personal' | 'Health'>('Work');
  const [priority, setPriority] = useState<'High' | 'Medium' | 'Low'>('Medium');
  const [dueDate, setDueDate] = useState('');
  const [dueTime, setDueTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validation
    if (!title.trim()) {
      setValidationMessage('Please enter a quest title');
      setShowValidationModal(true);
      return;
    }
    if (!dueDate) {
      setValidationMessage('Please select a due date for your quest');
      setShowValidationModal(true);
      return;
    }
    if (!dueTime) {
      setValidationMessage('Please select a due time for your quest');
      setShowValidationModal(true);
      return;
    }
    setLoading(true);
    try {
      await addGoal({
        title: title.trim(),
        category,
        priority,
        dueDate,
        dueTime
      });
      navigate('/goals');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-game-bg-pink dark:bg-[#1a1d29] p-6" data-id="element-693">
      <header className="flex items-center gap-4 mb-8" data-id="element-694">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="!p-2" data-id="element-695">
          <ArrowLeft className="w-6 h-6" data-id="element-696" />
        </Button>
        <h1 className="text-2xl font-fredoka font-bold text-game-dark dark:text-white" data-id="element-697">
          Create New Quest
        </h1>
      </header>

      <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-6" data-id="element-698">
        <Input label="Quest Title" placeholder="What do you want to accomplish?" value={title} onChange={e => setTitle(e.target.value)} required data-id="element-699" />

        <div data-id="element-700">
          <label className="block text-sm font-quicksand font-bold text-gray-700 dark:text-gray-300 mb-3" data-id="element-701">
            Category
          </label>
          <CategoryPicker selected={category} onSelect={setCategory} data-id="element-702" />
        </div>

        <div data-id="element-703">
          <label className="block text-sm font-quicksand font-bold text-gray-700 dark:text-gray-300 mb-3" data-id="element-704">
            Priority
          </label>
          <PrioritySelector selected={priority} onSelect={setPriority} data-id="element-705" />
        </div>

        <div className="grid grid-cols-2 gap-4" data-id="element-706">
          <Input label="Due Date" type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} required min={new Date().toISOString().split('T')[0]} data-id="element-707" />
          <Input label="Due Time" type="time" value={dueTime} onChange={e => setDueTime(e.target.value)} required data-id="element-708" />
        </div>

        <Button type="submit" className="w-full" size="lg" disabled={loading} data-id="element-709">
          {loading ? 'Creating Quest...' : 'Create Quest'}
        </Button>
      </form>

      <ConfirmModal isOpen={showValidationModal} onClose={() => setShowValidationModal(false)} onConfirm={() => setShowValidationModal(false)} title="Missing Information" message={validationMessage} confirmText="Got it" cancelText="" variant="warning" data-id="element-710" />
    </div>;
}